<template>
  <div class="sub-side-navigation d-none d-lg-block">
    <div class="header">
      {{ $t('pages.chat.rooms') }}
    </div>
    <proa-list-group>
      <proa-list-group-item
        v-for="groupChat in groupChats"
        :key="groupChat.id"
        :class="['group-chat-container', { 'active': groupChatId == groupChat.id }]"
        @click.native="onClickGroupChat(groupChat.id)"
      >
        <div class="title">
          <proa-badge :value="groupChat.unreadCount" v-if="groupChat.unreadCount && groupChatId != groupChat.id" class="title-badge"/>
          {{ groupChat.groupChatName }}
        </div>
      </proa-list-group-item>
    </proa-list-group>
  </div>
</template>

<script>
export default {
  name: 'SubSideNavigation',
  props: {
    groupChats: Array
  },
  computed: {
    groupChatId: function() { return this.$route.params.id }
  },
  methods: {
    onClickGroupChat:function(id) {
      if (id == this.groupChatId) return
      this.$router.push({ name: 'showChat', params: { id: id } })
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.sub-side-navigation {
  position: absolute;
  left: 54px;
  width: 240px;
  height: 100vh;
  background-color: white;
  box-shadow: 0px 0px 4px #00000026;

  .header {
    font-size: 11px;
    font-weight: 600;
    color: $secondary-color;
    padding: 20px 0 10px 15px;
    border-bottom: 1px solid $light-border-color;
  }

  .group-chat-container {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px 15px;

    &:hover {
      background-color: $light-gray-color;
    }

    &.active {
      cursor: default;
      color: $primary-color;
      font-weight: 600;
      background-color: $background-color;
    }

    .title {
      font-size: 13px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .title-badge {
        position: relative;
        bottom: 1.5px;
        margin-right: 10px;
      }
    }
  }
}
</style>
